import initialState from '../../../redux/reducers/initial-state';
import actionTypes from '../../../redux/actions/action-types';

const chartsPageReducer = (state = initialState.chartsPage, action) => {
  switch (action.type) {
    case actionTypes.chartsPage.set:
      return {
        ...state,
        ...action.data,
      };
    case actionTypes.chartsPage.updateCharts:
      return {
        ...state,
      };
    case actionTypes.chartsPage.setSelectFilter:
      return {
        ...state,
        ...action.data,
      };
    case actionTypes.chartsPage.pageUpdate:
      return {
        ...state,
        page: action.data.page,
      };
  }
  return state;
};

export default chartsPageReducer;
